export const MIN_TOUCH_SIZE = '42px';
